const translations = {
    downloadPdf: 'Download PDF'
};

export default translations;
